import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CheckCircleOutlined from '@mui/icons-material/CheckCircleOutlined';
import Divider from '@mui/material/Divider';
import Inventory2Outlined from '@mui/icons-material/Inventory2Outlined';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { theme } from '@omnigenbiodata/ui';
import { SampleKit } from '../../../../../../core/types/common.types';
import DetailRow from '../DetailRow';

const successTint = theme.palette.success.lighter;

interface SampleConfirmationPanelProps {
  sample: SampleKit;
  onContinue: () => void;
}

function formatDateTime(value: string) {
  return new Intl.DateTimeFormat('en-GB', {
    dateStyle: 'medium',
    timeStyle: 'short',
  }).format(new Date(value));
}

function SampleConfirmationPanel({ sample, onContinue }: SampleConfirmationPanelProps) {
  return (
    <Paper
      elevation={4}
      sx={{
        mt: 4,
        border: 1,
        borderColor: 'success.main',
        bgcolor: successTint,
        overflow: 'hidden',
      }}
    >
      <Box sx={{ height: 8, bgcolor: 'success.main' }} />

      <Box p={3}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2 }}>
          <Box
            sx={{
              width: 48,
              height: 48,
              borderRadius: '50%',
              bgcolor: 'background.paper',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
            }}
            aria-hidden="true"
          >
            <Inventory2Outlined color="success" sx={{ fontSize: 30 }} />
          </Box>

          <Box sx={{ minWidth: 0 }}>
            <Typography variant="h5" component="h2" sx={{ fontWeight: 700, color: 'primary.main' }}>
              Sample Kit Scanned
            </Typography>

            <Typography variant="body1" component="p" color="text.secondary">
              Please confirm the scanned sample kit details before continuing.
            </Typography>
          </Box>
        </Box>

        <Box component="dl" sx={{ m: 0 }}>
          <DetailRow label="Sample Barcode" value={sample.sampleBarcode} />

          {sample.linkDate && <DetailRow label="Link Date" value={formatDateTime(sample.linkDate)} />}
        </Box>

        <Divider sx={{ my: 3 }} />

        <Button
          variant="contained"
          color="primary"
          size="large"
          fullWidth
          startIcon={<CheckCircleOutlined />}
          onClick={onContinue}
          sx={{
            minHeight: 64,
            fontSize: '1.15rem',
            fontWeight: 700,
          }}
        >
          Continue to confirmation
        </Button>
      </Box>
    </Paper>
  );
}

export default SampleConfirmationPanel;
